var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import CircularProgress from '@material-ui/core/CircularProgress';
import classNames from 'classnames';
import React from 'react';
import { primary } from '../Styles/Colours';
import { Button, ButtonMode, ButtonSize } from './Button';
import styles from './Placeholder.module.css';
export var Placeholder = function (props) {
    var _a, _b;
    var infoText = props.infoText, actionText = props.actionText, action = props.action, icon = props.icon;
    var iconPosition = props.iconPosition || 'top';
    var placeholderStyles = classNames(styles.placeholder, (_a = {},
        _a[styles.left] = iconPosition === 'left',
        _a));
    var contentStyles = classNames(styles.content, props.contentClassName || '', (_b = {},
        _b[styles.left] = iconPosition === 'left',
        _b));
    var actionButton = props.actionButton;
    return (React.createElement("div", { className: placeholderStyles },
        icon,
        React.createElement("div", { className: contentStyles },
            infoText && React.createElement("div", { className: styles.text }, infoText),
            actionButton && (React.createElement(Button, { startIcon: actionButton.icon, mode: ButtonMode.solid, color: primary, size: ButtonSize.small, onClick: actionButton.onClick, testId: actionButton.testId }, actionButton.text)),
            actionText && (React.createElement("a", { className: styles.action, onClick: action }, actionText)))));
};
export var LoadingPlaceholder = function (props) {
    var size = props.size || 40;
    var thickness = props.thickness || 5;
    return React.createElement(Placeholder, __assign({ icon: React.createElement(CircularProgress, { size: size, thickness: thickness }) }, props));
};
